import { proxy } from 'valtio';

/**
 * Marks whether menus are currently visible.
 */
export const currentMenuVisiblityState = proxy({
  visible: true,
});
